import React, { useEffect, useState } from 'react';
import { IApp03TaskEvidence } from '../../types';
import * as services from '../../services';
import { DateService } from '../../services';

interface Props {
    taskID: number;
}

export const TaskEvidenceView: React.FC<Props> = ({ taskID }) => {
    const [data, setData] = useState<IApp03TaskEvidence[]>([]);
    const [loading, setLoading] = useState<boolean>(false);

    const service = new services.App03TaskEvidencesService();
    const fileService = new services.ZFileService();

    useEffect(() => {
        load();
    }, [taskID]);

    const load = async () => {
        setLoading(true);
        const res = await service.readAllForEvList(taskID);
        setData(res);
        setLoading(false);
    };

    const downloadFile = async (item: any) => {
        if (item.AttachmentType === "File") {
            await fileService.downloadFile(item.FileUniqueID, item.Title);
        } else if (item.AttachmentType === "Link") {
            window.open(item.Title, "_blank");
        }
    };

    const renderComment = (text: string) => {
        if (!text) return null;

        const paragraphs = text.split(/\n\s*\n/); // split by empty lines

        return (
            <>
                {paragraphs.map((p, i) => {
                    const lines = p.split('\n');

                    return (
                        <p key={i} style={{ margin: '6px 0', lineHeight: '1.5' }}>
                            {lines.map((line, j) => (
                                <React.Fragment key={j}>
                                    {line}
                                    {j < lines.length - 1 && <br />}
                                </React.Fragment>
                            ))}
                        </p>
                    );
                })}
            </>
        );
    };

    return (
        <div>
            {data.map((item, index) => (
                <div key={index} style={{ marginBottom: 20 }}>

                    {/* Date + By */}
                    <div style={{ fontWeight: 'bold' }}>
                        {DateService.dateToReadableDateTime(item['DateAdded'])} - {item["AddedBy"]}
                    </div>

                    {/* Comment */}
                    <div style={{ marginTop: 5 }}>
                        {renderComment(item.Details)}
                    </div>

                    {/* File */}
                    {item.AttachmentType !== "None" && item.Title && (
                        <div
                            style={{
                                marginTop: 5,
                                textDecoration: 'underline',
                                cursor: 'pointer',
                                color: '#0078d4'
                            }}
                            onClick={() => downloadFile(item)}
                        >
                            {item.Title}
                        </div>
                    )}

                </div>
            ))}

            {data.length === 0 && !loading && (
                <div style={{ color: '#666' }}>No discussion available</div>
            )}
        </div>
    );
};